import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, ObservableInput, of } from 'rxjs';
import { ErrorModel } from '~api/models/error.model';
import { ApiService } from '~generated-api/api.service';

/**
 * Provides error catching & handling functionality, exposes `ApiService` for API functions invocation.
 */
@Injectable()
export class ApiWrapperService {
  protected readonly api = inject(ApiService);

  /**
   * Catches HTTP error, creates `ErrorModel` and returns it as stream value.
   */
  protected catchError<TInput>() {
    return catchError<TInput, ObservableInput<ErrorModel>>((err: HttpErrorResponse) => {
      const errorModel = ErrorModel.fromErrorResponse(err);
      console.error(errorModel);
      return of(errorModel);
    });
  }
}
